import React, {Component} from 'react';

class ErrorBoundaryForComponents extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  componentDidCatch(error, info) {
    this.setState({hasError: true});
  }

  render() {
    const {errorMessage = 'Something Went Wrong.'} = this.props;
    if (this.state.hasError) {
      return (
        <div className="app-wrapper page-error-container animated slideInUpTiny animation-duration-3">
          <div className="page-error-contect">
            <p className="text-center zoomIn animation-delay-20 animated">{errorMessage}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundaryForComponents;
